/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react'

import { useTranslation } from 'next-i18next'
import { Box } from '@mui/material'
import { EmtTypography, useMobile } from 'emt-components-v2'
import NextImage from 'next/image'
import VariantImages from '@/assets/BaseVariantImages'
import NavLink from 'next/link'
import { usePetsittingMode } from '@/store/usePetsittingMode'

const isPetsittingMode = usePetsittingMode.getState().isPetsittingMode

export const Benefices: React.FC = () => {
  const { t } = useTranslation('petsitter')
  const [isMobile] = useMobile()
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <EmtTypography variant="body2" fontSize="18px" fontWeight={700}>
        {isPetsittingMode ? t('profile.benefits.titlePetsitting') : t('profile.benefits.title')}
      </EmtTypography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr',
          gap: isMobile ? '20px' : '20px 25px',
        }}
      >
        {benefits.map((benefit, index) => (
          <Box
            key={index}
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: '13px',
              padding: '15px',
              backgroundColor: '#fff',
              borderRadius: '16px',
              border: '1px solid #E8E8EA',
            }}
          >
            <NextImage src={benefit.image} quality={100} alt={''} />
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
              <EmtTypography variant="body2" fontWeight="700" color="#1D1929">
                {t(`${benefit.titleKey}`)}
              </EmtTypography>
              {benefit.descriptionKey && (
                <EmtTypography variant="caption" fontWeight="600" color="#77757F">
                  {t(benefit.descriptionKey)}
                </EmtTypography>
              )}
              {benefit.learnMore && (
                <NavLink href={t(`${benefit.learnMore}`) || '#'} target="_blank" rel="noopener noreferrer">
                  <EmtTypography
                    variant="body2"
                    color="purple.dark"
                    fontWeight="600"
                    sx={{ textDecoration: 'underline', fontSize: '12px', marginTop: '8px' }}
                  >
                    {t('profile.benefits.learnMore')}
                  </EmtTypography>
                </NavLink>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

const benefits = isPetsittingMode
  ? [
      {
        titleKey: 'profile.benefits.itemsPetsitting.quality.title',
        descriptionKey: 'profile.benefits.itemsPetsitting.quality.description',
        image: VariantImages.Quality,
        learnMore: 'profile.benefits.itemsPetsitting.quality.link',
      },
      {
        titleKey: 'profile.benefits.itemsPetsitting.annulation.title',
        descriptionKey: 'profile.benefits.itemsPetsitting.annulation.description',
        image: VariantImages.Annulation,
        learnMore: 'profile.benefits.itemsPetsitting.annulation.link',
      },
      {
        titleKey: 'profile.benefits.itemsPetsitting.security.title',
        descriptionKey: 'profile.benefits.itemsPetsitting.security.description',
        image: VariantImages.Security,
        learnMore: 'profile.benefits.itemsPetsitting.security.link',
      },
      {
        titleKey: 'profile.benefits.itemsPetsitting.veterinaryAssistance.title',
        descriptionKey: 'profile.benefits.itemsPetsitting.veterinaryAssistance.description',
        image: VariantImages.AssistanceVeterinaire,
        learnMore: 'profile.benefits.itemsPetsitting.veterinaryAssistance.link',
      },
      {
        titleKey: 'profile.benefits.itemsPetsitting.veterinaryInsurance.title',
        descriptionKey: 'profile.benefits.itemsPetsitting.veterinaryInsurance.description',
        image: VariantImages.AssuranceVeterinaire,
        learnMore: 'profile.benefits.itemsPetsitting.veterinaryInsurance.link',
      },
      {
        titleKey: 'profile.benefits.itemsPetsitting.damageInsurance.title',
        descriptionKey: 'profile.benefits.itemsPetsitting.damageInsurance.description',
        image: VariantImages.AssuranceDommages,
        learnMore: 'profile.benefits.itemsPetsitting.damageInsurance.link',
      },
    ]
  : [
      {
        titleKey: 'profile.benefits.items.quality.title',
        descriptionKey: 'profile.benefits.items.quality.description',
        image: VariantImages.Quality,
        learnMore: 'profile.benefits.items.quality.link',
      },
      {
        titleKey: 'profile.benefits.items.annulation.title',
        descriptionKey: 'profile.benefits.items.annulation.description',
        image: VariantImages.Annulation,
        learnMore: 'profile.benefits.items.annulation.link',
      },
      {
        titleKey: 'profile.benefits.items.security.title',
        descriptionKey: 'profile.benefits.items.security.description',
        image: VariantImages.Security,
        learnMore: 'profile.benefits.items.security.link',
      },
      {
        titleKey: 'profile.benefits.items.veterinaryAssistance.title',
        descriptionKey: 'profile.benefits.items.veterinaryAssistance.description',
        image: VariantImages.AssistanceVeterinaire,
        learnMore: 'profile.benefits.items.veterinaryAssistance.link',
      },
      {
        titleKey: 'profile.benefits.items.veterinaryInsurance.title',
        descriptionKey: 'profile.benefits.items.veterinaryInsurance.description',
        image: VariantImages.AssuranceVeterinaire,
        learnMore: 'profile.benefits.items.veterinaryInsurance.link',
      },
      {
        titleKey: 'profile.benefits.items.damageInsurance.title',
        descriptionKey: 'profile.benefits.items.damageInsurance.description',
        image: VariantImages.AssuranceDommages,
        learnMore: 'profile.benefits.items.damageInsurance.link',
      },
    ]
